module.exports = __webpack_public_path__ + "static/media/IMG-15.42675324.jpg";